import { useState } from "react";
// import axios from "axios";
import api from "../api"; // path is correct from components/

import "./Sign.css";

function Sign({ onLogin }) {
  const [mode, setMode] = useState("user"); // user | admin | register
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // ================= USER LOGIN =================
  const handleUserLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/login", {
        mobile_number: phone.trim(),
        password:password.trim(),
        user_type: "user", // ✅ static
      });

      // alert("Login Success");

      if (res.data?.access_token) {
        localStorage.setItem("token", res.data.access_token);
      }

      onLogin();
    } catch (error) {
      alert("Login Failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= ADMIN LOGIN =================
  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const res= await api.post("/login", {
        mobile_number: phone.trim(),
        password:password.trim(),
        user_type: "employee", // ✅ static
      });
      // even if you don’t use it yet

      localStorage.setItem("token", res.data.access_token);

      // alert("Admin verified successfully ✅");

      setPhone("");
      setPassword("");
      setMode("register"); // 🔥 move to register form
    } catch (error) {
      alert("Admin verification failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= REGISTER USER =================
  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/register-employee", {
        mobile_number: phone.trim(),
        password:password.trim(),
      });

      alert("User registered successfully 🎉");

      setPhone("");
      setPassword("");
      setMode("user"); // back to login
    } catch (error) {
      alert("Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main">
      {/* LEFT IMAGE */}
      <div className="left login-left">
        <img src={require("../assets/login.png")} alt="login" />
      </div>

      {/* RIGHT FORM */}
      <div className="right">
        <div className="login-card">
          <div className="form-logo">
            <img src={require("../assets/form-login-logo.png")} alt="logo" />
          </div>

          <h3>
            {mode === "user" && "EMI Management System"}
            {mode === "admin" && "Admin Login"}
            {mode === "register" && "Register User"}
          </h3>

          <form
            onSubmit={
              mode === "user"
                ? handleUserLogin
                : mode === "admin"
                ? handleAdminLogin
                : handleRegister
            }
          >
            {/* PHONE */}
            <div className="sign-input">
              <span className="sign-icon">
                <img src={require("../assets/phone.png")} alt="phone" />
              </span>
              <input
                type="tel"
                placeholder="Phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            {/* PASSWORD */}
            <div className="sign-input">
              <span className="sign-icon">
                <img src={require("../assets/key.png")} alt="key" />
              </span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* OPTIONS */}
            <div className="options">
              <label>
                <input
                  type="checkbox"
                  checked={showPassword}
                  onChange={(e) => setShowPassword(e.target.checked)}
                />{" "}
                Show password
              </label>
              <div>
                {mode === "user" && (
                  <button
                    type="button"
                    className="admin-log"
                    onClick={() => {
                      setPhone("");
                      setPassword("");
                      setMode("admin");
                    }}
                  >
                    Admin Login
                  </button>
                )}
              </div>
            </div>

            {/* SUBMIT */}
            <div className="submit-wrap">
              <button type="submit" disabled={loading}>
                {loading
                  ? "Please wait..."
                  : mode === "user"
                  ? "Login"
                  : mode === "admin"
                  ? "Verify Admin"
                  : "Register User"}
              </button>
            </div>

            {/* BACK */}
            {(mode === "admin" || mode === "register") && (
              <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="admin-log"
                  onClick={() => {
                    setPhone("");
                    setPassword("");
                    setMode("user");
                  }}
                >
                  ← Back to Login
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Sign;
